var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowLeft12X21 = function SvgArrowLeft12X21(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 21
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.496 20.049a1.714 1.714 0 0 0 0-2.431l-7.36-7.342 7.36-7.342A1.719 1.719 0 0 0 9.065.503L.507 9.056a1.708 1.708 0 0 0 0 2.429l8.557 8.557a1.714 1.714 0 0 0 2.431 0Z"
  })));
};
export default SvgArrowLeft12X21;